import { Route, Routes } from 'react-router';

import OnesuranceRecommendations from './components/OnesuranceRecommendations/OnesuranceRecommendations';
import useHasOnesuranceConnection from './hooks/useHasOnesuranceConnection';

export default function OnesuranceRoutes() {
  const hasOnesuranceConnection = useHasOnesuranceConnection();

  if (!hasOnesuranceConnection) return null;

  return (
    <Routes>
      <Route path="/recommendations" element={<OnesuranceRecommendations />} />
    </Routes>
  );
}
